"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.waitForGlobal = exports.loadScript = exports.default = void 0;
const loadScript = function (url, key) {
  return new Promise(function (resolve, reject) {
    if (key === undefined) {
      console.warn("[ScriptLoader] No key passed into loadScript");
      resolve(true);
    }
    if (typeof key === "function" && !key() || typeof key === "string" && !window[key]) {
      const script = document.createElement("script");
      script.src = url;
      script.async = true;
      script.defer = true;
      script.onload = resolve;
      script.onerror = reject;
      document.head.appendChild(script);
      return;
    }
    resolve(true);
  });
};
exports.loadScript = loadScript;
const waitForGlobal = function (key) {
  if (window[key]) {
    return window[key];
  }
  setTimeout(function () {
    waitForGlobal(key);
  }, 100);
};
exports.waitForGlobal = waitForGlobal;
var _default = exports.default = loadScript;